import { render, staticRenderFns } from "./UploadingFilesMD.vue?vue&type=template&id=60e9e9ae&scoped=true"
import script from "./UploadingFilesMD.vue?vue&type=script&lang=js"
export * from "./UploadingFilesMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e9e9ae",
  null
  
)

export default component.exports